<template>
  <a-popover
    v-model:visible="isMenuVisible"
    placement="bottomRight"
    trigger="click"
    class="user-menu"
  >
    <button
      class="user-menu__avatar"
      type="button"
      data-test="header-user-avatar-btn"
    >
      <img
        src="@/assets/user-avatar.svg"
        alt="user"
        width="40"
        height="40"
      >
    </button>

    <template #content>
      <div class="user-menu__email">{{ user.email }}</div>

      <router-link
        v-for="menuItem in userMenu"
        :key="menuItem.route"
        class="user-menu__item"
        :to="{ name: menuItem.routeName }"
        :data-test="menuItem.qaSlug"
        @click="closeMenu"
      >
        <BaseIcon :name="menuItem.icon" />
        <span>{{ menuItem.title }}</span>
      </router-link>

      <button
        class="user-menu__item user-menu__item--logout"
        type="button"
        data-test="header-logout-btn"
        @click="showLogoutModal"
      >
        <BaseIcon name="log-out" />
        <span>{{ $t('form_button_log_out') }}</span>
      </button>
    </template>
  </a-popover>
</template>

<script>
import { mapGetters } from 'vuex';
import { Popover } from 'ant-design-vue';
import BaseIcon from '@/components/BaseIcon.vue';

export default {
  name: 'UserMenu',

  components: {
    BaseIcon,
    APopover: Popover,
  },

  data() {
    this.userMenu = [
      {
        title: this.$t('page_settings_menu_notifications'),
        icon: 'notification',
        routeName: 'EmailNotifications',
        qaSlug: 'header-notifications-link',
      },
      {
        title: this.$t('page_settings_menu_subscriptions'),
        icon: 'document',
        routeName: 'Subscriptions',
        qaSlug: 'header-subscriptions-link',
      },
    ];

    return {
      isMenuVisible: false,
    };
  },

  computed: {
    ...mapGetters('auth', ['user']),
  },

  methods: {
    closeMenu() {
      this.isMenuVisible = false;
    },
    showLogoutModal() {
      this.closeMenu();

      this.$store.dispatch('base/openModal', 'LogoutConfirm');
    },
  },
};
</script>

<style lang="scss" scoped>
.user-menu {
  $this: 'user-menu';

  &__avatar {
    @include reset-btn;
  }

  &__email {
    color: $light_purple;
    font-size: 16px;
    margin-bottom: 24px;
  }

  &__item {
    @include reset-btn;
    display: flex;
    align-items: center;
    font-size: 17px;
    line-height: 34px;
    letter-spacing: 0.75px;
    color: $primary_gray;
    width: 100%;
    margin-bottom: 14px;

    .icon {
      stroke: $dark_gray;
      flex-shrink: 0;
      margin-right: 12px;
    }

    &--logout {
      margin-top: 34px;
      margin-bottom: 0;
    }
  }
}
</style>
